import { useQuery } from "@tanstack/react-query";
import API from "@/api";

function useTank(nurseryId: string, tankId: string, enabled: boolean = true) {
  const { isPending, error, data } = useQuery({
    queryKey: ["tanks", nurseryId, tankId],
    queryFn: () => API.getTank(nurseryId, tankId),
    enabled: enabled
  });

  return {
    isPending,
    error,
    data
  };
}

export default useTank;
